<template>
  <div :class="user.language + ' ' + user.theme">
    <div class="alert" :class="alert.visible?'visible '+ alert.type:alert.type">
      <p>{{alert.message}}</p>
      <button v-if="alert.type == 'error'" @click="alert.visible=false">X</button>
    </div>
    <div class="blackout" :class="menu?'':'hide'"></div>
    <div @click="menu = true" class="burger">| |</div>
    <div
      v-if="loggedIn == true"
      class="side-bar"
      v-on-clickout="()=>{menu=false}"
      :class="menu?'open-menu':''"
    >
      <div
        @click="dropdown?dropdown='':dropdown='w--open'"
        data-delay="0"
        class="head-box-drop w-dropdown"
        tabindex="0"
        @blur="dropdown=''"
      >
        <div class="dropdown-toggle-other-projects w-dropdown-toggle">
          <h1 class="heading">
            {{activeSite.name}}
            <svg
              v-if="access.length>1"
              class="c-input__icon"
              viewBox="0 0 20 20"
              width="20"
              height="20"
            >
              <path
                d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
              />
            </svg>
          </h1>
        </div>
        <nav :class="'dropdown-other-projects-list w-dropdown-list '+dropdown">
          <h2
            v-for="(access, i) in access"
            :key="i"
            class="other-projects-head"
            @click="changeSite(access)"
          >{{access.name}}</h2>
        </nav>
      </div>
      <ul class="mainlist">
        <li @click="menu=false" v-for="collection in collections" :key="collection._id">
          <router-link
            v-if="collection.visible == true"
            :to="'/list/'+collection._id"
            class="collection collection-link collection-name"
          >
            {{collection.name}}
            <p class="totals">{{collection.totalItems}}</p>
          </router-link>
        </li>
      </ul>
      <div class="bagel-box w-clearfix">
        <BagelLogo />
        <router-link to="/settings" class="settings w-inline-block">
          <i class="bf-settings" />
        </router-link>
      </div>
    </div>
    <div v-if="(activeSite && collections.length && refresher) || loggedIn==false">
      <router-view
        @showField="showField($event)"
        @changeList="($event)=>{items[activeCol]?'':items[activeCol]=[];activeCol=$event}"
        :activeList="items[activeCol]?items[activeCol] : 'waiting'"
        :collection="activeCollection"
        @alertMessage="alertMessage($event)"
      />
    </div>
    <PopUp v-if="popup" :poplink="popup" />
    <div id="myframe"></div>
  </div>
</template>

<style>
.blackout {
  opacity: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: black;
  z-index: 3;
  transition: all 0.5s ease;
  display: block;
}
.blackout.hide {
  transition: all 0.5s ease;
  opacity: 0;
  display: none;
}
.rtl .totals {
  float: left;
}
.totals {
  font-size: 12px;
  float: right;
  opacity: 0.3;
}
.open-menu {
  width: 80%;
  left: 0;
}
.rtl .open-menu {
  left: auto;
  right: 0;
}
.burger {
  display: none;
}
#myframe {
  display: block;
}
@media screen and (max-width: 767px) {
  .burger {
    cursor: pointer;
    transform: rotateZ(90deg);
    display: inline-block;
    padding: 20px;
    font-size: 20px;
  }
}

@import url(./css/components.css);
@import url(./css/style.css);

.light .router-link-active {
  color: #ffffff;
  background-color: #4d8cf4;
}
</style>

<script>
import { mixin as clickout } from "vue-clickout";
import PopUp from "@/views/popup.vue";
import BagelLogo from "@/uiComponents/BagelLogo.vue";
import { setTimeout } from "timers";
//import { setTimeout } from "timers";

export default {
  name: "app",
  mixins: [clickout],
  components: {
    PopUp,
    BagelLogo
  },
  beforeResolve(to, from, next) {
    this.menu = false;
    next();
  },
  data() {
    return {
      activeSite: {
        siteName: "loading..."
      },
      collections: [],
      menu: false,
      alert: "",
      popup: "",
      dropdown: "",
      loggedIn: "undetermined",
      set: {
        domain: "",
        rtf: "",
        preLink: "https://cors.bagelstudio.co/api.webflow.com/",
        token: "",
        siteID: "",
        siteName: "",
        user: {
          language: "",
          theme: ""
        }
      },
      access: [],
      rawAccess: [],
      schemas: {},
      items: {},
      user: "",
      activeCol: "",
      refresher: true,
      readCols: []
    };
  },
  methods: {
    showField(event) {
      var index = this.collections.indexOf(
        this.collections.find(e => {
          return e._id == this.activeCol;
        })
      );
      this.collections[index].fields.find(e => {
        return e.slug == event.slug;
      }).show = event.show;
    },
    logger(event) {
      console.log(event);
    },
    alertMessage(alert) {
      this.alert = {
        visible: true,
        type: alert.type,
        message: alert.message
      };
      if (alert.type != "error") {
        setTimeout(() => {
          this.alert.visible = false;
        }, 3500);
      }
    },
    getCollections() {
      this.collections = [];
      db.collection("collections")
        .orderBy("name", "asc")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            var colData = doc.data();
            colData._id = doc.id;
            this.collections.push(colData);
          });
        });
    },
    changeSite(site) {
      this.setSite(site);
      if (site != this.access[0]) {
        this.$router.push("/");
        var newAcc = [];
        $.each(this.access, (i, e) => {
          var add = admindb.doc("/sites/" + e.siteID);
          if (e != site) {
            newAcc.push(add);
          } else {
            newAcc.unshift(add);
          }
        });
        admindb
          .doc("/users/" + this.user.uid)
          .update({
            access: newAcc
          })
          .then(() => {
            var index = this.access.indexOf(site);
            this.access.splice(index, 1);
            this.access.unshift(site);
          });
      }
    },
    setSite(site) {
      let url = `https://${site.domain}/404?setCookie=bglAdmin`
      console.log("Setting url: "+ url)
      $("#myframe").html(
        `<iframe src="${url}"></iframe>`
      );
      setTimeout(() => {
        $("#myframe").remove();
      }, 5000);
      this.collections = [];
      this.activeSite = site;
      window.siteID = site.siteID;
      if (this.activeSite.type == "webflow") {
        window.wfToken = this.activeSite.token;
      } else {
        window.wfToken = null;
      }
      var firebaseConfig = {
        apiKey: site.apiKey,
        projectId: site.projectId
      };
      if (site.storageBucket) {
        firebaseConfig.storageBucket = site.storageBucket;
      }
      if (!window.secondary) {
        window.secondary = {};
      }
      if (!secondary[site.projectId]) {
        window.secondary[site.projectId] = firebase.initializeApp(
          firebaseConfig,
          site.name
        );
      }
      window.db = secondary[site.projectId].firestore();
      window.fs = secondary[site.projectId].storage();
      this.getCollections();
    },
    getFirebase(Col) {
      if (!this.readCols.includes(Col)) {
        this.readCols.push(Col);
        getdata.firebase(Col, res => {
          this.items[Col] = [];
          this.refresher = false;
          if (res == []) {
            this.items[Col] = "empty";
          } else {
            res.forEach(doc => {
              this.items[Col].push(doc);
            });
          }
          this.refresher = true;
        });
      }
    },
    collector() {
      var link =
        this.set.preLink +
        "sites/" +
        this.set.siteID +
        "/collections?access_token=" +
        this.set.token +
        "&api_version=1.0.0";
      $.getJSON(link, content => {
        var newarray = content.filter(
          ({ name }) => !new RegExp(/^-/, "gi").test(name)
        );
        this.collections = newarray.sort((a, b) => (a.slug > b.slug ? 1 : -1));
      });
    },
    date(d) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      var date = new Date(d);
      var day = date.getDate();
      var monthIndex = monthNames[date.getMonth()];
      var year = date.getFullYear();
      return monthIndex + " " + day + ", " + year;
    },
    async isUser(uid) {
      this.loggedIn = true;
      var userinfo = await firebase
        .firestore()
        .doc("users/" + uid)
        .get();
      this.user = userinfo.data();
      if (!this.user.theme) {
        this.user.theme = "light";
      }
      this.user.uid = uid;
      var sited = false;

      this.access = await Promise.all(
        this.user.access.map(async (e, i) => {
          var site = await admindb.doc("sites/" + e.id).get();
          var siteData = site.data();
          siteData.siteID = site.id;
          return siteData;
        })
      );
      this.setSite(this.access[0]);
    }
  },
  computed: {
    activeCollection() {
      if (this.collections && this.activeCol) {
        return this.collections.find(e => e._id == this.activeCol);
      } else {
        return "";
      }
    },
    activeList() {
      return this.activeCol ? this.items[this.activeCol] : false;
    }
  },
  mounted() {
    this.activeCol = this.$route.params.col;
    window.vm = this;
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        vm.isUser(user.uid);
      } else {
        `<iframe src=//${vm.activeSite.domain}/404?rmCookie=bglAdmin></iframe>`;
        vm.$router.push("/login");
        vm.loggedIn = false;
        vm.access = "";
        vm.activeSite = "";
      }
    });
  }
};
</script>